import React from 'react';
import { Link } from 'react-router-dom';
import PageTitle from '../shared/PageTitle';

const NotFound = () => {
  // Determine where to redirect user based on user role
  // Just using a generic dashboard link for simplicity
  const dashboardLink = "/";

  return (
    <div className="container text-center py-5">
      <div className="mb-4">
        <span className="display-1 fw-bold text-danger">404</span>
      </div>
      
      <PageTitle icon="fa-exclamation-triangle" title="Page Not Found" className="mb-4" />
      
      <p className="lead mb-5">
        The page you are looking for might have been removed, had its name changed, 
        or is temporarily unavailable.
      </p>
      
      <div className="d-flex justify-content-center">
        <Link to={dashboardLink} className="btn btn-primary me-2">
          <i className="fas fa-home me-2"></i>
          Go to Dashboard
        </Link>
        
        <button 
          onClick={() => window.history.back()} 
          className="btn btn-outline-secondary"
        >
          <i className="fas fa-arrow-left me-2"></i>
          Go Back
        </button>
      </div>
    </div>
  );
};

export default NotFound; 